import React from 'react';
import Card from '@mui/material/Card';
import { Box, Divider, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import CardPersonSchool from './CardPersonSchool';
import { IPersonPerimeter } from 'services/SchoolPerimeterService/types';

interface CardPerimeterSchoolProps {
  title: string;
  iconProp?: string;
  people: IPersonPerimeter[];
  titleTime: string;
}

const CardPerimeterSchool: React.FC<CardPerimeterSchoolProps> = ({
  title,
  iconProp,
  people = [],
  titleTime,
}) => {
  return (
    <Card
      sx={{
        width: '100%',
        height: { xs: '80vh', md: '92vh' },
        p: 2,
        backgroundColor: 'var(--app-surface-2)',
        display: 'flex',
        flexDirection: 'column',
        my: { xs: 2 },
      }}
    >
      {/* Header */}
      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Typography 
              variant="h6" 
              sx={{ 
                color: '#fff', 
                fontWeight: 600,
                fontSize: '1.1rem'
              }}
            >
              {title}
            </Typography>
            <Box
              sx={{
                backgroundColor: '#90caf9',
                color: '#1a1a2e',
                borderRadius: '12px',
                px: 1.5,
                py: 0.5,
                minWidth: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: '0.9rem',
              }}
            >
              {people.length}
            </Box>
          </Box>
          {iconProp && (
            <Box
              component="img"
              src={iconProp}
              alt="icon"
              sx={{
                width: 40,
                height: 40,
                objectFit: 'contain',
                filter: 'brightness(0.9)',
              }}
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
          )}
        </Box>
        <Divider sx={{ backgroundColor: 'rgba(255, 255, 255, 0.12)' }} />
      </Box>

      {/* Lista de Pessoas */}
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        {people.length > 0 ? (
          people.map((person) => (
            <Box key={`${person.personType}-${person.id}`} mb={1}>
              <CardPersonSchool
                image={person.image}
                widthProps={'100px'}
                name={person.name}
                date={
                  person.lastEventTime
                    ? new Date(person.lastEventTime).toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit',
                      })
                    : 'N/A'
                }
                lastEventTime={person.lastEventTime || undefined}
                titleTime={titleTime}
                personType={person.personType}
                isOutdueEntry={person.isOutdueEntry}
                outdueEntryHours={person.outdueEntryHours}
                responsibles={person.responsibles}
                responsibleName={person.responsibleName}
              />
            </Box>
          ))
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              mt: 8,
              gap: 2,
            }}
          >
            <InboxIcon sx={{ fontSize: 64, color: 'rgba(255, 255, 255, 0.3)' }} />
            <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.5)' }}>
              Nenhuma pessoa encontrada
            </Typography>
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default CardPerimeterSchool;
